import { useEffect, useRef, useState } from "react";
export function useInView(options = { threshold: 0.15, once: true }) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) { setInView(true); if (options.once) observer.unobserve(entry.target); }
        else if (!options.once) setInView(false);
      },
      { threshold: options.threshold ?? 0.15 }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, [options.threshold, options.once]);
  return [ref, inView];
}
export function useCountUp(target, { duration = 1600, start = 0, decimals = 0 } = {}) {
  const [ref, inView] = useInView({ threshold: 0.3, once: true });
  const [value, setValue] = useState(start);
  useEffect(() => {
    if (!inView) return;
    const startTime = performance.now();
    let raf;
    const tick = (now) => {
      const progress = Math.min((now - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setValue(start + (target - start) * eased);
      if (progress < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, target, duration, start]);
  return [ref, decimals > 0 ? value.toFixed(decimals) : Math.floor(value).toLocaleString()];
}
